module.exports = "/_next/static/images/bg-a1d388ca.png";